import React from "react";

import { Notification, Loader } from "@stellar/design-system";
import { Icon } from "@stellar/design-system";

import "./styles.scss";
import { useReceiverEmailPreview } from "@/apiQueries/useReceiverEmailPreview";

interface DisbursementEmailPreviewProps {
  walletName: string;
  language: string;
}

export const DisbursementEmailPreview: React.FC<DisbursementEmailPreviewProps> = ({
  walletName,
  language,
}: DisbursementEmailPreviewProps) => {
  const { data, isLoading, isError, error } = useReceiverEmailPreview({
    language,
    walletName: walletName || undefined,
  });

  return (
    <div className="DisbursementEmailPreview">
      <p className="DisbursementEmailPreview__label">
        This preview reflects your organization name, logo, and language.
      </p>

      <div className="DisbursementEmailPreview__client">
        {isLoading ? (
          <div className="DisbursementEmailPreview__loading">
            <Loader />
          </div>
        ) : null}

        {isError ? (
          <Notification variant="error" title="Could not load email preview">
            {error?.message ?? "Please try again."}
          </Notification>
        ) : null}

        {!isLoading && !isError && data ? (
          <>
            {/* Mock email client toolbar */}
            <div className="DisbursementEmailPreview__toolbar">
              <button className="DisbursementEmailPreview__toolbarBtn" aria-label="Back">
                <Icon.ChevronLeft />
              </button>
              <div className="DisbursementEmailPreview__toolbarActions">
                <Icon.Mail01 />
                <Icon.DotsHorizontal />
              </div>
            </div>
            {/* Email subject row */}
            <div className="DisbursementEmailPreview__subject">
              <span className="DisbursementEmailPreview__subjectText">{data.subject}</span>
              <span className="DisbursementEmailPreview__badge DisbursementEmailPreview__badge--amber">
                INTERNAL
              </span>
              <span className="DisbursementEmailPreview__badge DisbursementEmailPreview__badge--gray">
                INBOX
              </span>
            </div>
            {/* Sender row */}
            <div className="DisbursementEmailPreview__sender">
              <div className="DisbursementEmailPreview__senderAvatar">V</div>
              <div className="DisbursementEmailPreview__senderInfo">
                <div className="DisbursementEmailPreview__senderName">
                  {walletName || "VIA Wallet"}
                  <span className="DisbursementEmailPreview__senderDate">
                    &nbsp;· Today, 9:00 AM
                  </span>
                </div>
              </div>
              <div className="DisbursementEmailPreview__senderActions">
                <Icon.ChevronLeft />
                <Icon.DotsHorizontal />
              </div>
            </div>
            {/* Email body */}
            <iframe
              className="DisbursementEmailPreview__frame"
              title="Receiver invitation email preview"
              srcDoc={data.html}
              sandbox=""
            />
          </>
        ) : null}
      </div>
    </div>
  );
};
